"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var CalendarTo = function CalendarTo(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2["default"])({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    ref: ref
  }, props), (0, _core.jsx)("path", {
    d: "M25.618 21.553a1.41 1.41 0 011.399 1.432v4.307a5.509 5.509 0 0011.017-.154v-4.164a1.41 1.41 0 011.41-1.421H53.16a1.411 1.411 0 011.41 1.465v4.407a5.508 5.508 0 005.509 5.21l.216-.004a5.509 5.509 0 005.292-5.504v-4.142a1.41 1.41 0 011.41-1.432h4.11a5.508 5.508 0 015.486 5.508v46.8a5.508 5.508 0 01-5.508 5.508H21.508A5.508 5.508 0 0116 73.861v-46.8l.004-.216a5.509 5.509 0 015.504-5.292zm44.024 22.033H22.908a1.378 1.378 0 00-1.377 1.422v27.586c0 .76.616 1.377 1.377 1.377h46.734c.76 0 1.377-.616 1.377-1.377v-27.63c0-.761-.617-1.378-1.377-1.378zM64.692 57.3c.762 0 1.38.618 1.38 1.38v9.24a1.38 1.38 0 01-1.38 1.38h-9.24a1.38 1.38 0 01-1.38-1.38v-9.24c0-.762.618-1.38 1.38-1.38h9.24zM32.536 16.033a2.754 2.754 0 012.755 2.754v8.274a2.755 2.755 0 01-5.509.088v-8.362a2.754 2.754 0 012.754-2.754zM60.08 16a2.754 2.754 0 012.754 2.754v8.307a2.754 2.754 0 01-5.508.055v-8.362A2.754 2.754 0 0160.079 16z",
    fill: "currentColor"
  }));
};

var _default = (0, _react.forwardRef)(CalendarTo);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(CalendarTo, "CalendarTo", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/CalendarTo.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/CalendarTo.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();